// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".criteria-strip_aec47535{max-height:160px;overflow:hidden}.criteria-strip__scrollable_d08e9049{padding-right:15px}.clear-all-button_aef2ec68{display:inline-block;margin-bottom:.667rem;vertical-align:middle;border-left:thin solid #84919b;padding-left:.667rem}", ""]);
// Exports
export var criteriaStrip = "criteria-strip_aec47535";
export var criteriaStripScrollable = "criteria-strip__scrollable_d08e9049";
export var clearAllButton = "clear-all-button_aef2ec68";
export default ___CSS_LOADER_EXPORT___;
